import React, { useMemo, useState, useEffect, useContext } from 'react'
import './styles/SeasonalBarChart.css'
import SelectBox from './SelectBox'
import TextBox from './TextBox'
import TextBoxInc from './TextBoxInc'
import CheckBox from './CheckBox'
import BarChart from './BarChart'
import Tippy from '@tippyjs/react'
import { monthsAndQtrs, maxDaysOut, minDaysOut, customYearsDesc } from './Common'
import { redirectBackFromSeasonals } from './Common'
import { appserverURL } from './Common'
import { getTodayDate } from './Common'
import { UserContext } from './UserContext'
import { BsFillCaretUpFill, BsFillCaretDownFill, BsQuestionCircle, BsPlus } from "react-icons/bs";
import { BiLineChart } from "react-icons/bi";
import { userAccessToSelectedSecurity } from './Common'
import { getSelectedIDFromSecuritiesList2 } from './Common'
import { setCookie } from './Common'
import { UIcolors } from './Common'
import { opp_dashboard_dialog_content } from './Common'
import { brand, trend_chart_left_gap_days, minYears } from './Common'
import { checkTokenExpired } from './Common'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faFileExcel, faHome } from "@fortawesome/free-solid-svg-icons";
// import { FaArrowCircleLeft, FaArrowCircleRight, ImArrowLeft, ImArrowRight } from "react-icons/fa";
// import {fa-solid fa-circle-left} from "@fortawesome/free-solid-svg-icons";

import { FaAngleRight } from "react-icons/fa";

const SeasonalBarChart = (props) => {

  const { wpUserLevels, browserH, browserW, rdd, token, globalTextSize, infoTextSize, loggedinUser, debug } = useContext(UserContext)



  var showDate2 = false;



  // these are display for from and to dates if 2021-09-02 to 2021-09-24, they should be:
  // sep 2 to sep 24
  const [dateStartDisp, SetDateStartDisp] = useState(() => {
    return (props.startDate.substring(5, 10))
  })

  const [dateEndDisp, SetDateEndDisp] = useState(() => {
    let ded = '';
    if (props.daysOut !== '') {

      // console.log('props.startDate, props.daysOut=',props.startDate, props.daysOut)

      let ded = incrementDate(props.startDate, props.daysOut).substring(5, 10);

    }
    return (ded)
  });

  const [dateEnd, SetDateEnd] = useState(() => {
    let ded = '';
    if (props.daysOut !== '') {

      // console.log('props.startDate, props.daysOut=',props.startDate, props.daysOut)

      let ded = incrementDate(props.startDate, props.daysOut);

    }
    return (ded)
  });



  const [daysOutList, setDaysOutList] = useState([])
  const [seasonalYearsList, setSeasonalYearsList] = useState(() => {
    // initially set the years to 30 years manually.  make it work by getting metaData from appserver later
    var tmp = [];
    for (var i = 5; i <= 30; i++)
      tmp.push({ id: i, value: i.toString(), label: i.toString() })
    return (tmp)
  })

  // const [secondLayerControlsVisible, SetSecondLayerControlsVisible] = useState('none') // for smartphone portrait only
  const [secondLayerControlsOpen, SetSecondLayerControlsOpen] = useState(false) // for smartphone portrait only
  const [secondLayerDisplay, SetSecondLayerDisplay] = useState('none')


  //const [symbolError,SetSymbolError] = useState('false') // used to trigger removing bad ticker symbol from textbox

  // find the index number from the value of the selected security.  want to just pass the index number to flask
  // const getSelectedIDFromSecuritiesList = () => {
  //   for (var i = 0; i < props.securityTypeList.length; i++) {
  //     if (props.securityTypeList[i]['value'] === props.selectedSecurity) break
  //   }

  //   return (i)
  // }



  //-----------------------------------------------------------------------------------------------------------------------
  function daysBetweenDates(date0, date1) { //increment date in format of yyyy-mm-dd and return same format

    const date1Obj = new Date(date1);
    const date0Obj = new Date(date0);

    // Calculate the time difference in milliseconds
    const timeDifference = date1Obj - date0Obj;

    // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
    const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000));

    return Math.abs(daysDifference);

  }
  //-----------------------------------------------------------------------------------------------------------------------
  function incrementyear(dateStr, num) { //increment year in format of yyyy-mm-dd and return same format

    let substrings = dateStr.split('-');
    let year = parseInt(substrings[0]);
    year = year + num;

    return `${year}-${substrings[1]}-${substrings[2]}`
  }
  //-----------------------------------------------------------------------------------------------------------------------
  function incrementDate(dateStr, days) { //increment date in format of yyyy-mm-dd and return same format
    var d = new Date(dateStr + 'T00:00:00')
    d.setDate(d.getDate() + parseInt(days))
    var incDate = d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
    return (incDate)
  }
  //-----------------------------------------------------------------------------------------------------------------------
  useMemo(() => {
    var tmp = []
    for (var i = minDaysOut; i <= maxDaysOut; i++) tmp.push({ id: i, value: i.toString(), label: i.toString() })
    setDaysOutList(tmp)

    // get setSeasonalYearsRange from appserver for the symbol - first and last date in the csv

    // var id = getSelectedIDFromSecuritiesList()
    var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
    var asURL = appserverURL()
    var url = `${asURL}/StockMetaData/${id}/${props.symbol}?token=${token}`



    // let token_expired = checkTokenExpired(token);



    if (token.length > 0 && props.symbol.length > 0) {

      // var decoded = jwt_decode(token);
      // let token_expiration = decoded['exp']
      // let currentUtcSeconds = Math.floor(Date.now() / 1000);
      // console.log('ddddddddddddddddddddddddddddddddddddddddddddddd ', token_expiration, currentUtcSeconds)
      // // let token_expired = token_expiration < currentUtcSeconds ? false : true;
      // let token_expired = currentUtcSeconds > token_expiration ? true : false;



      // create static list of years incase fetch fails
      // for (i = 5; i < 26; i++)     tmp.push({ id: i, value: i.toString(), label: i.toString() })


      fetch(url)
        .then(res => {
          const contentType = res.headers.get("content-type");

          // console.log('res.status=',res.status)

          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else if (res.status === 429) { // too many requests
            // let trigger = res.headers.get("trigger");
            // props.SetDialogType('info-box'); //429
            props.SetDialogType('rate-limit'); //429
            // props.SetDialogProp({ title: 'Too Many Requests', contentText: ratelimitMessage(trigger, loggedinUser), button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            props.SetInfoBoxVisible(true)
          }
          else if (res.status === 500) {  // stock symbol wasn't found
            // console.log('symbol=', props.symbol)
            props.SetDialogType('info-box')
            props.SetDialogProp({ title: 'Symbol not Found', contentText: props.symbol + ' is not found', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            props.SetInfoBoxVisible(true);
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((t) => {
          if (t !== undefined) {
            // console.log('seasonalbarchart fetch stock meta data =', t, typeof (t))

            // check if there is an error in the result
            var lst = t['StockMetaData'];
            if (lst.includes('Not Traded')) {
              props.SetSymbol('')
              props.SetDialogType('info-box')
              props.SetDialogProp({ title: 'Symbol Not Traded', contentText:lst, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
              props.SetInfoBoxVisible(true);
            }
            else {
              var y1 = parseInt(lst[0]);
              var y2 = parseInt(lst[1]);

              // console.log('years range:', y1, y2)
              tmp = []

              tmp.push({ id: 'odd', value: 'odd', label: 'Odd' })
              tmp.push({ id: 'even', value: 'even', label: 'Even' })
              tmp.push({ id: 'pe0', value: 'pe0', label: 'Pres Election' })
              tmp.push({ id: 'pe1', value: 'pe1', label: 'Pres Election+1' })
              tmp.push({ id: 'pe2', value: 'pe2', label: 'Pres Election+2' })
              tmp.push({ id: 'pe3', value: 'pe3', label: 'Pres Election+3' })

              // tmp.push({ id: 'bull', value: 'bull', label: 'Bull Market Years' })
              // tmp.push({ id: 'bear', value: 'bear', label: 'Bear Market Years' })



              for (i = 5; i <= y2 - y1; i++)     tmp.push({ id: i, value: i.toString(), label: i.toString() })
              setSeasonalYearsList(tmp)

              let maxYears = tmp[tmp.length - 1]['value'] // max years for the new security selected
              // compare it to the current years selected.  if current selected years is larger than max years, set the current years to max years

              if (parseInt(props.seasonalYears) > parseInt(maxYears)) { // 10/22/2023
                props.SetSeasonalYears(maxYears);
              }

              // console.log('seasonalyears list is now length=',tmp.length,tmp[tmp.length-1]['value'],props.seasonalYears)
              // console.log(typeof(tmp.length,tmp[tmp.length-1]['value']),typeof(props.seasonalYears))

            }
          }
        })
    }




  }, [props.symbol])
  //-----------------------------------------------------------------------------------------------------------------------
  // calculate end date 9/10/2023 - I don't know how it was working before
  //-----------------------------------------------------------------------------------------------------------------------
  useEffect(() => {

    if (props.daysOut !== '') {
      SetDateStartDisp(props.startDate.substring(5, 10))
      let ded = incrementDate(props.startDate, props.daysOut - 1);

      SetDateEndDisp(ded.substring(5, 10));
      SetDateEnd(ded);
    }


  }, [props.startDate, props.daysOut])

  //-----------------------------------------------------------------------------------------------------------------------
  useEffect(() => { //fetch barchart data


    // SetSymbolError(false)

    // var id = getSelectedIDFromSecuritiesList()

    // console.log('************************props.selectedSecurity=',props.selectedSecurity)

    var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
    let asURL = appserverURL()

    let days_out_processed = props.daysOut - 1

    // decrement daysOut by 1 for cosemtics change 9/4/2022 

    var url = `${asURL}/ChartData4/${id}/${props.startDate}/${props.symbol}/${days_out_processed}/${props.seasonalYears}`

    if (props.trimYear !== 0) {  // 12/10/2023
      url = url + `/${props.trimYear}`
    }

    url += `?token=${token}`



    // passing 2 additional parameters, compareSecurity[0] which is resourceID and compareSecurity[1] which is symbol // 9/9/2023
    // var url = `${asURL}/ChartData4/${id}/${props.startDate}/${props.symbol}/${days_out_processed}/${props.seasonalYears}/${props.compareSecurity[0]}/${props.compareSecurity[1]}?token=${token}`
    // console.log('mmmmmmmmmmmmmmmmmmmmmmmain chartdata4 url=',url)

    // this is for current/historical flag to be passed for stockscore.  will do it later
    // let flag='0'; if (props.stockScoreCurrent)flag='1'; //parseInt didn't work so using if instead
    // var url = `${asURL}/ChartData4/${id}/${props.startDate}/${props.symbol}/${props.daysOut}/${props.seasonalYears}/${flag}?token=${token}`
    // console.log('url=', url)

    var ttmp = {};

    if (token && token.length > 0 && props.symbol.length > 0) { // if (token is addded to prevent the race condition that crashes the app
      fetch(url)
        .then(res => {
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else if (res.status === 429) { // too many requests
            props.SetDialogType('rate-limit'); //429
            props.SetInfoBoxVisible(true)
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((t) => {

          if (t !== undefined) {

            // console.log('ttttttttttttttcharatdata4',t)

            if (t["ChartData4"].includes('Not Enough Data')) { // when its 0 length - its due to no trade - its an old symbol

              // console.log('t["ChartData4"]=',t["ChartData4"])

              props.SetDialogType('info-box')
              props.SetDialogProp({ title: 'Not Enough Data', contentText: `${props.symbol} does not have enough data. At least 5 years are required`, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
              props.SetInfoBoxVisible(true);
              props.SetSeasonalBarChartData([])
              props.SetTradeDetailData([])
              props.SetConsolidatedSeasonalData([])
              props.SetSymbol('')
              props.SetLineChartYear(0)
            }
            else {

              props.SetSeasonalBarChartData(t["ChartData4"])
              props.SetTradeDetailData(t["stats"])

              // figure out if this chart should be considered long or short
              var pos = 0, neg = 0;
              var lastYearOfData = 0

              t["ChartData4"].forEach((r) => {
                lastYearOfData = r['year'];
                var plist = r['pct'].split(',');
                if (plist[0] >= 0) pos++;
                if (plist[0] < 0) neg++;
              })


              // props.SetBarChartLongOrShort((pos >= neg) ? 'long' : 'short'); // this screwed up AMD buy and hold 
              props.SetBarChartLongOrShort(t["stats"]["Trade Dir"])

              props.SetLineChartYear(lastYearOfData);
              var eDate = incrementDate(props.startDate, props.daysOut - 1).substring(5, 10);

              // this is the image name in case user wants to download the image
              let download_img_name = `TradeWave Opportunity Export for ${props.symbol} date range  ${props.startDate} to ${eDate}.jpg`
              if (props.monthsAndQtrs !== 'Months & Qtrs') {
                download_img_name = props.symbol + '_' + props.monthsAndQtrs;
                download_img_name += '.jpg'
              }
              props.SetDownloadImageName(download_img_name);

            }

          }

        });

    }
    // }, [props.startDate, props.symbol, props.daysOut, props.seasonalYears, props.showMAE, props.showMFE, token])
  }, [props.startDate, props.symbol, props.daysOut, props.seasonalYears, token]) // removed showMFE and MAE not needed 9/6/2022
  //--------------------------------------------------------------------------------------------------------------------
  // this fetch is for the comparison security - spx by default
  //--------------------------------------------------------------------------------------------------------------------

  useEffect(() => { //fetch comparison barchart data

    let asURL = appserverURL()

    // let days_out_processed = props.daysOut - 1

    // let startDate = props.startDate;
    let startDate = getTodayDate().substring(0, 4) + '-' + props.compareSecurity[2]; // this is now set to '-01-01' // this is january first for the current year
    let days_out_processed = props.compareSecurity[3] - 1;  // this should result to 364 days. -1 is for counting 01-01 as a day - dropping feb 29 on leap years


    let url = `${asURL}/ChartData4/${props.compareSecurity[0]}/${startDate}/${props.compareSecurity[1]}/${days_out_processed}/${props.seasonalYears}?token=${token}`
    // console.log('ccccccccccccccccccccccccccccccccccccccccompare chartdata4 url=', url)

    if (token.length > 0 && props.symbol.length > 0) {
      fetch(url)
        .then(res => {
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((t) => {

          if (t !== undefined) {
            // console.log('compare t["ChartData4"]=', t["ChartData4"])
            props.SetCompareSecurityBarChartData(t["ChartData4"])
            props.SetCompareSecurityTradeDetailData(t["stats"])

            // console.log('comparison t[stats]=', t['stats'])

            // figure out if this chart should be considered long or short
            var pos = 0, neg = 0;
            var lastYearOfData = 0

            t["ChartData4"].forEach((r) => {
              lastYearOfData = r['year'];
              var plist = r['pct'].split(',');
              if (plist[0] >= 0) pos++;
              if (plist[0] < 0) neg++;
            })

            props.SetCompareSecurityLongOrShort((pos >= neg) ? 'long' : 'short');
          }
        })
    }
  }, [props.startDate, props.symbol, props.daysOut, props.seasonalYears, props.compareSecurity[0], props.compareSecurity[1], props.daysOut, props.seasonalYears, token])


  //-----------------------------------------------------------------------------------------------------------------------
  function isCurrentYearLeap() {
    const currentYear = new Date().getFullYear();
    return (currentYear % 4 === 0 && currentYear % 100 !== 0) || (currentYear % 400 === 0);
  }



  //--------------------------------------------------------------------------------------------------------------------
  // this fetch is for the buy and hold of the currently displayed security
  // it should only envoke if the number of years is changed
  //--------------------------------------------------------------------------------------------------------------------

  useEffect(() => { //fetch comparison barchart data

    // console.log('eneeeeeeeeeeeeeeeeeeeeeeeeeenvoked')

    // let daysThisYear = 366; // 366 is buy and hold days for normal years vs 367 for leap years
    // if (isCurrentYearLeap()) daysThisYear = 367;

    let base_year = getTodayDate().substring(0, 4)
    let date_0 = base_year + '-01-01'
    let date_1 = incrementyear(date_0, 1)
    let days = daysBetweenDates(date_0, date_1)


    let asURL = appserverURL()
    let resourceID = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
    // let startDate = base_year + '-01-01'; // this is now set to '-01-01' // this is january first for the current year
    let url = `${asURL}/ChartData4/${resourceID}/${date_0}/${props.symbol}/${days}/${props.seasonalYears}?token=${token}`

    if (token.length > 0 && props.symbol.length > 0) {
      fetch(url)
        .then(res => {
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((t) => {

          if (t !== undefined) {
            // console.log('compare t["ChartData4"]=', t["ChartData4"])
            // props.SetCompareSecurityBarChartData(t["ChartData4"])
            props.SetSecurityBHstats(t["stats"])

            // console.log('BH stats t[stats]=', t['stats'])


          }
        })
    }
  }, [props.seasonalYears, props.symbol, token])


  //--------------------------------------------------------------------------------------------------------------------

  //get seasonal chart data from appserver
  useEffect(() => { //fetch trendchart data

    var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
    let asURL = appserverURL()
    let td = getTodayDate()
    var start_date = td.substring(0, 5) + '01-01'; // when checkbox is checed this is the start date
    let opp_start_date = props.startDate; // passing this to consolidate seasonal chart to fix the dec chart start date when pe cycles in 



    if (!props.janDecDateRange) {

      // start_date = incrementDate(td, -60)  // go back 2 months and then take first day of the month as start date
      // start_date = start_date.substring(0, 8) + '01'
      start_date = props.trendChartStartDate;
    }
    // console.log('before trend chart',id,props.symbol,props.seasonalYears,start_date)

    var url = `${asURL}/consolidated_seasonal_chart2/${id}/${props.symbol}/${props.seasonalYears}/${start_date}/${opp_start_date}?token=${token}`

    

    // console.log('trend chart status date=',props.trendChartStartDate)
    if (token.length > 0 && props.symbol.length > 0) {
      // this doesn't make
      // console.log('consolidated seasonal chart URL = ', url)
      // console.log('start_date=',start_date)
      fetch(url)
        .then(res => {

          const contentType = res.headers.get("content-type");

          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else if (res.status === 429) { // too many requests
            let trigger = res.headers.get("trigger");
            props.SetDialogType('rate-limit'); //429
            props.SetInfoBoxVisible(true)
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((t) => {
          if (t !== undefined) {
            if (t['cons_seas_chart'].length < 5) {
              props.SetConsolidatedSeasonalData([])
            }
            else {
              props.SetConsolidatedSeasonalData(t['cons_seas_chart'])
            }
            // console.log('consolidated seasonal chart - trend chart loaded',t['cons_seas_chart'].length,props.symbol)
          }
        })
    }
  }, [props.refreshKey, props.symbol, props.seasonalYears, props.janDecDateRange, props.trendChartStartDate, token])
  //--------------------------------------------------------------------------------------------------------------------
  const checkboxChanged = (event) => {
    // console.log(event.target.value, event.target.checked)

    if (event.target.value === 'MFE') {
      props.setShowMFE(event.target.checked)
      setCookie('MFE', event.target.checked.toString(), 300)
    }
    if (event.target.value === 'MAE') {
      props.setShowMAE(event.target.checked)
      setCookie('MAE', event.target.checked.toString(), 300)
    }
  }
  //--------------------------------------------------------------------------------------------------------------------
  // react changed the behavior of onchange - 
  const handleBlur = (event) => {
    if (event.target.id === 'date') {

      if (props.startDate !== event.target.value) {

        let old_start_date = props.startDate
        // check if the typed date is valid
        let isValid = true;
        let d = event.target.value;
        let dl = d.split('-');
        if (dl.length !== 3 || dl[0].length !== 4 || dl[1].length !== 2 || dl[2].length != 2) isValid = false;
        else {
          let y = parseInt(dl[0]);
          let m = parseInt(dl[1]);
          let d = parseInt(dl[2]);
          if (y < 1920) isValid = false;
          if (m < 1 || m > 12) isValid = false;
          if (d < 1 || d > 31) isValid = false;
        }
        if (isValid) {
          props.SetStartDate(event.target.value);
        }
        else { // entered date is invalid

          props.SetStartDate(props.consolidatedSeasonalData[0][0]); // change invalid date to first day in seasonal chart 
          props.SetDialogType('info-box');
          props.SetDialogProp({ title: 'Invalid Date', contentText: `${d} Date must be in YYYY-MM-DD format.`, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
          props.SetInfoBoxVisible(true)
        }

      }

    }


    if (event.target.id === 'symbol') {
      if (props.symbol !== event.target.value) {



        let asURL = appserverURL()
        let id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity);
        let url = `${asURL}/NameFromTicker/${id}/${event.target.value}?token=${token}`

        fetch(url)
          .then((res) => {
            return res.json();
          })
          .then((g) => {

            // console.log('g1111111111111111111111111111111',g)

            if (g['name'] != "") {
              props.SetSymbol(event.target.value);
              props.SetConsolidatedSeasonalData([])
              
              console.log('ppppppppppppprops.startDate 615',props.startDate);

              let trend_chart_start_date = incrementDate(props.startDate, -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
              props.SetTrendChartStartDate(trend_chart_start_date)
              props.SetCompany(g['name'])
            }
            else {
              if (event.target.value !== '' && props.symbol !== '') {
                props.SetDialogType('info-box');
                props.SetDialogProp({ title: 'Symbol not Found', contentText: event.target.value + ' not found', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
                props.SetInfoBoxVisible(true)
                props.SetSymbol('')
                props.SetSeasonalBarChartData([])
                props.SetLineChartYear(0)
                props.SetConsolidatedSeasonalData([])
              }
            }

          })
          .catch(err => {
            console.log('NameFromTicker error in SeasonalBarChart =', err.message)
          })
      }
    }
  }
  //--------------------------------------------------------------------------------------------------------------------
  const handleEnter = (event) => {

    // console.log('symbol before =', props.symbol)


    if (event.key === 'Enter') {

      if (event.target.id === 'date') {
        // props.SetMonthsAndQtrs('Months & Qtrs')
        // props.SetStartDate(event.target.value)

        // let old_start_date = props.startDate
        // check if the typed date is valid
        let isValid = true;
        let d = event.target.value;
        let dl = d.split('-');
        if (dl.length !== 3 || dl[0].length !== 4 || dl[1].length !== 2 || dl[2].length !== 2) isValid = false;
        else {
          let y = parseInt(dl[0]);
          let m = parseInt(dl[1]);
          let d = parseInt(dl[2]);
          if (y < 1920) isValid = false;
          if (m < 1 || m > 12) isValid = false;
          if (d < 1 || d > 31) isValid = false;
        }
        if (isValid) {
          props.SetStartDate(event.target.value);
        }
        else { // entered date is invalid
          props.SetStartDate(props.consolidatedSeasonalData[0][0]); // change invalid date to first day in seasonal chart 
          // props.SetStartDate(old_start_date); // didn't work - changing it to first day of seasonal chart. this is because startDate not changed so the useEffect is not triggered
          props.SetDialogType('info-box');
          props.SetDialogProp({ title: 'Invalid Date', contentText: `${d} Date must be in YYYY-MM-DD format.`, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
          props.SetInfoBoxVisible(true)
        }

      }
      if (event.target.id === 'symbol') {

        let asURL = appserverURL()
        let id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity);
        let url = `${asURL}/NameFromTicker/${id}/${event.target.value}?token=${token}`

        fetch(url)
          .then((res) => {
            return res.json();
          })
          .then((g) => {

            // console.log('g22222222222222222222222222222222222',g)

            if (g['name'] != "") {
              props.SetSymbol(event.target.value);
              props.SetConsolidatedSeasonalData([]);

              console.log('ppppppppppppprops.startDate 699',props.startDate);

              let trend_chart_start_date = incrementDate(props.startDate, -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
              props.SetTrendChartStartDate(trend_chart_start_date)
              props.SetCompany(g['name'])
            }
            else {
              if (event.target.value !== '') {
                props.SetDialogType('info-box');
                props.SetDialogProp({ title: 'Symbol not Found', contentText: event.target.value + ' not found', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
                props.SetInfoBoxVisible(true)
                props.SetSymbol('')
                props.SetSeasonalBarChartData([])
                props.SetLineChartYear(0)
                props.SetConsolidatedSeasonalData([])
              }
            }
          })
          .catch(err => {
            console.log('NameFromTicker error in SeasonalBarChart =', err.message)
          })
      }
      props.SetRowIndexClicked(-1)
    }
  }
  //-----------------------------------------------------------------------------------------------------------
  // 
  //-----------------------------------------------------------------------------------------------------------

  const selectboxChanged = (event) => {

    // console.log('select changed', event.target.value)

    // console.log(event.target.id, event.target.value)
    if (event.target.id === 'daysout') {
      props.SetDaysOut(event.target.value)
      props.SetMonthsAndQtrs('Months & Qtrs')
    }

    if (event.target.id === 'years') {
      if (event.target.value !== props.seasonalYears) {
        props.SetSeasonalYears(event.target.value.toLowerCase())
        props.SetLineChartYear(0) // 2021-11-30

        //-------------------------------------------------------------------------------------------------------------------
        // not sure why I'm setting jandec to true when its presidential election years!!! - commenting it out on 5/10/2025
        //-------------------------------------------------------------------------------------------------------------------
        // let val = Number(event.target.value) ? true : false; // if false its a custom year - only show seasonalchart with jan-dec checked
        // if (val === false) props.SetJanDecDateRange(true);

        props.SetConsolidatedSeasonalData([]) //2022-07-18
      }
    }

    if (event.target.id === 'monthsAndQtrs') {

      if (loggedinUser === '0' || (wpUserLevels.length === 1 && wpUserLevels[0] === '1')) {
        props.SetDialogType('free-register') // stop non logged-in users from changing dates
        props.SetInfoBoxVisible(true);
        return; //user 0 cannot change months and qtrs
      }

      let retArray = userAccessToSelectedSecurity(props.securityTypeList2, props.selectedSecurity)
      if (retArray[0] === 'F') {
        props.SetDialogType('free-register')
        props.SetInfoBoxVisible(true);
        return;
      }

      props.SetMonthsAndQtrs(event.target.value)

      if (event.target.value !== "Months & Qtrs") {
        for (var i = 0; i < monthsAndQtrs.length; i++) { // find the numeric id for the selected pulldown 
          if (monthsAndQtrs[i]['label'] === event.target.value) {
            break;
          }
        }

        // console.log('event.target.value=', event.target.value, i)

        if (event.target.value === 'Buy & Hold') { // 9/27/2022 - set jan-dec when buy and hold 
          props.SetJanDecDateRange(true);
          props.SetConsolidatedSeasonalData([])
        }


        // get current year
        var d = new Date();
        var y = d.getFullYear();
        // get the date range selected
        var date0 = y + '-' + monthsAndQtrs[i]['range'][0]
        var date1;


        if (event.target.value === 'Today to Year End') {
          date0 = getTodayDate();

          date1 = date0.substring(0, 4) + '-12-31'; // last day of the current year
          let date = new Date(date1);
          let dayOfWeek = date.getDay();
          if (dayOfWeek === 6) date1 = date0.substring(0, 4) + '-12-30'; // when last day of the year falls on saturday - use previous friday as last day of the year
          if (dayOfWeek === 0) date1 = date0.substring(0, 4) + '-12-29'; // when last day of the year falls on sunday   - use previous friday as last day of the year

          console.log('date0,date1', date0, date1)
        }



        if (event.target.value === 'Year to Date') {
          date1 = getTodayDate();
        }


        // reverse the date range
        else if (event.target.value === 'Reverse Date Range') { // reverse the range; for ex. if range is october, reverse would be all year except october
          let current_date0 = props.startDate;
          let current_date1 = incrementDate(current_date0, props.daysOut - 1)


          // console.log('rrrrrrrrrrrrrrrrrre3', date0, date1)



          // let base_year = current_date0.substring(0, 4);
          let base_year = getTodayDate().substring(0, 4); //10/14/2023


          let reverse_date0 = incrementDate(current_date1, 1)

          // console.log('---------------------reverse started d0,days', current_date0, current_date1, props.daysOut)

          //decrement year

          while (reverse_date0.substring(0, 4) > base_year) { // date0 must be in the current year
            reverse_date0 = incrementyear(reverse_date0, -1);
          }

          let reverse_date1 = incrementDate(current_date0, -1) //decrement by 1 day

          // check if buy & hold is being reversed.  it cannot
          var is_buy_and_hold_being_reversed = false;


          if (current_date0.substring(current_date0.length - 5) === current_date1.substring(current_date1.length - 5))
            is_buy_and_hold_being_reversed = true;

          if (reverse_date1 < reverse_date0) reverse_date1 = incrementyear(reverse_date1, 1) //increament by 1 year

          // console.log('reverse_date0 and reverse date1 = ', reverse_date0, reverse_date1)

          date0 = reverse_date0;
          date1 = reverse_date1;
          props.SetMonthsAndQtrs('Months & Qtrs')

        }
        else {
          date1 = y + '-' + monthsAndQtrs[i]['range'][1] // if winter increment year

        }

        if ((Date.parse(date1) > Date.parse(date0)) === false) { // date1 year need to be incremented by 1
          y++; // increment because winter date1 is one year later
          date1 = y + '-' + monthsAndQtrs[i]['range'][1]
        }

        var daysOut = Math.floor((Date.parse(date1) - Date.parse(date0)) / 86400000) + 1;  // cosmetic increment by 1 - 9/4/2022

        // console.log('................................reverse date0, date1,daysOut,', date0, date1, daysOut)



        if (is_buy_and_hold_being_reversed === true) { // bad way of stopping reversing of buy and hold - didn't want to deal with some of the messy conditions - it was working


          let content = `Buy & Hold Date Range cannot be reversed.  To reverse a Date Range, the length has to be less than 1 year.`
          props.SetDialogType('info-box');
          props.SetDialogProp({ title: 'Reverse Date Range Error', contentText: content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
          props.SetInfoBoxVisible(true);


        }
        else {


          if (date0 !== props.startDate) { // if this if statement is not there if date0 is the same as props.startDate, the trend chart disappears 10/25/2023

            let new_trend_chart_start_date = incrementDate(date0, -trend_chart_left_gap_days) // this is the new date0 for the trend chart 
            props.SetTrendChartStartDate(new_trend_chart_start_date)
            props.SetStartDate(date0)
            props.SetConsolidatedSeasonalData([])

            props.SetJanDecDateRange(false);  // 5/9/2025 - removing Jan Dec to make sure we can see all of the range

          }

          props.SetDaysOut(daysOut)

        }


      }

    }

    props.SetRowIndexClicked(-1); //remove the selection on opp table

  }
  //-----------------------------------------------------------------------------------------------------------
  const barClicked = (year) => {

    props.SetLineChartYear(year)

    if (rdd.isMobile) {
      if (browserH > browserW) {// portrait
        props.chartTo(1)
      }
      else { //landscape - only for landscape smartphones
        if (!rdd.isTablet) props.chartTo(2)
        else props.chartTo(2) // added for landscape tablet when it points back to desktop view
      }
    }
    else {
      props.chartTo(2)
    }
  }

  //---------------------------------------
  // dynamic styles for mobile
  //---------------------------------------
  let barchartHeight = "92%"
  let barchartControlsHeight = '8%'
  var navArrowSize = 30

  if (rdd.isMobile) {
    if (rdd.isTablet) {
      if (browserH > browserW) {
        barchartHeight = "88%"
        barchartControlsHeight = '12%'
      }
    }
    else {
      barchartHeight = "88%"
      barchartControlsHeight = '12%'
    }
  }

  //-----------------------------------------------------------------------------------------------------------
  const barchartStyle = {
    height: barchartHeight,
    backgroundColor: UIcolors(loggedinUser)['background_barchart'],
    borderLeft: '1px solid lightgray'
  }
  //-----------------------------------------------------------------------------------------------------------
  const barchartControlsStyle = {
    height: barchartControlsHeight,
    display: "flex",
    alignItems: "center",
    backgroundColor: "blue",
    // fontFamily:'san-serif'
    // justifyContent: "space-between",
    // marginRight: "5px"
  }

  //-----------------------------------------------------------------------------------------------------------
  //---------------------------------------
  var textsize = "12px";
  var displayElement = new Array(15)
  var descpart1 = "inline";
  var questionSize = 15;
  var questionDivWidth = '3%';
  var svFont = '6.0vw';
  var svIconSize = '20';
  var LSsquareSize = "14px"; // this is size of the long short square added on 8/31/2022
  var barchartControlDateWidth = '10';  // added to fix tablet portrait issue 8/31/2022
  var barchartControlTickerWidth = '5'; // added to fix tablet portrait issue 8/31/2022
  var SVDIVwidth = '7%';
  var ticker_description = props.company;


  var icon_size_plus = 33;


  for (var i = 0; i <= 15; i++)displayElement[i] = "flex";
  displayElement[12] = "none";
  displayElement[14] = "none";

  if (rdd.isMobile && !rdd.isTablet && browserH > browserW) { // smartphone portrait
    for (var ii = 7; ii <= 11; ii++)displayElement[ii] = "none"; //remove display of text and select/options in this mode
    textsize = "2.8vw";
    descpart1 = "none"; // don't show the first part of description - its too long
    // displayElement[1] = "none"; // remove the right left nav arrow from top bar for now
    displayElement[12] = "flex"  //this is smartphone portrait 2nd layer control
    displayElement[13] = "flex"; // this is question mark help on mobile portrait
    displayElement[14] = "flex"; // this is for seasonal chart icon for mobile portrait
    displayElement[2] = "none";
    displayElement[0] = "none"; // removed the left arrow to home
    navArrowSize = 30
    questionDivWidth = '9%';
    svFont = '8vw';
  }
  else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) { //smartphone landscape
    displayElement[13] = "flex"; //question mark
    displayElement[3] = "none";
    displayElement[1] = "flex"; // remove the right left nav arrow from top bar for now
    displayElement[2] = "none";
    questionDivWidth = '5%';
    displayElement[14] = "flex"; // this is for seasonal chart icon for mobile portrait
  }
  else if (rdd.isMobile && rdd.isTablet && browserH > browserW) { // tablet portrait
    displayElement[3] = "flex";
    descpart1 = "none";
    SVDIVwidth = '6%';

    barchartControlDateWidth = "8";   // this is for text box 8/31/2022
    barchartControlTickerWidth = "4"; // this is for text box 8/31/2022
    displayElement[14] = "flex"; // seasonal chart icon for mobile portrait both tablet and smartphones
    svIconSize = '28';
    // displayElement[1] = "none"; // remove the right left nav arrow from top bar for now
    displayElement[2] = "none";  // right single arrow
    if (browserH > 1024) {   //ipad pro
      navArrowSize = 50
      questionSize = 30;
      svIconSize = '40';
      LSsquareSize = '20px';
      icon_size_plus = 40;
    }
    else {
      navArrowSize = 40;
      questionSize = 22;
      icon_size_plus = 30;
    }

    questionDivWidth = '5%';
  }
  else if (rdd.isMobile && rdd.isTablet && browserH < browserW) { //tablet landscape
    displayElement[3] = "flex";
    descpart1 = "none";

    displayElement[1] = displayElement[2] = "none";

    icon_size_plus = 27;

    if (browserW > 1024) {   //ipad pro
      questionSize = 20;
      questionDivWidth = '5%';
    }
    else {
      questionSize = 16;
      questionDivWidth = '5%';
    }
  }
  else if (!rdd.isMobile) {
    displayElement[1] = "flex";                                  // desktop
    displayElement[2] = "none"; // don't need nav arrows in desktops

    if (ticker_description != null && ticker_description.length > 40) {
      if (rdd.isMacOs) {
        let trunc_chars = 35;
        if (rdd.isSafari) trunc_chars = 32;
        ticker_description = ticker_description.substring(0, trunc_chars) + '..'; // only show the first 40 characters of description
      }
    }
  }

  //-----------------------------------------------------------------------------------------------------------
  const longShortSquare = {
    width: LSsquareSize,
    height: LSsquareSize,
    backgroundColor: props.barChartLongOrShort === 'long' ? 'green' : 'red',
    marginRight: "5px",

    // display:"flex"
  }
  //-----------------------------------------------------------------------------------------------------------

  const StyleNavDiv = {
    // backgroundColor: "red",
    display: displayElement[0],
    alignItems: "center",
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleBackArrow = {
    // backgroundColor: "red",
    // display:"none"
    // marginRight: "7px",
    // width: "20px",
    height: "100%",
    display: displayElement[1],
    // flexDirection: 'column',
    // justifyContent:'center',
    alignItems: 'center'

  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleForwardArrow = {
    // backgroundColor: "rgba(0,152,0,0.8",
    height: "100%",
    display: displayElement[2],
    // alignItems: "center"
    marginLeft: "39%"
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleDescription = {
    // backgroundColor: "pink", 
    fontSize: infoTextSize,
    color: "white",
    flexGrow: "2",
    justifyContent: "end",
    display: displayElement[3],

  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleLSSquare = {
    // backgroundColor: "rgba(102,52,250,0.8",
    display: "flex",
    alignItems: "center",

    display: displayElement[4],
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleMFE = {
    // backgroundColor: "rgba(152,152,0,0.8",
    display: displayElement[5],
    fontSize: globalTextSize,
    alignItems: "center",
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleMAE = {
    // backgroundColor: "rgba(100,200,0,0.8",
    display: displayElement[6],
    fontSize: globalTextSize,
    alignItems: "center",
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleStartDate = {
    // backgroundColor: "rgba(0,0,0,0.8",
    display: displayElement[7],
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleSymbol = {
    // backgroundColor: "rgba(0,0,252,0.8",
    display: displayElement[8],
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleDaysOut = {
    // backgroundColor: "rgba(252,0,252,0.8",
    display: displayElement[9],
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleSeasonalYears = {
    // backgroundColor: "rgba(125,125,125,0.8",
    display: displayElement[10],
  }
  //-----------------------------------------------------------------------------------------------------------
  const StyleMQtrs = {
    // backgroundColor: "rgba(152,252,152,0.8",
    display: displayElement[11],
  }
  //---------------------------------------

  const handleForwardClick = () => {
    // props.SetLineChartYear('2020')
    if (rdd.isMobile && !rdd.isTablet && browserH > browserW) {
      props.chartTo(1)
    }
    else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) {
      props.chartTo(2)
    }
    else if (rdd.isMobile && rdd.isTablet && browserH > browserW) {
      props.chartTo(1)
    }
    // console.log('here I am')
  }
  //-----------------------------------------------------------------------------------------------------------
  const handleBackClick = () => {
    if (rdd.isMobile && !rdd.isTablet && browserH < browserW) {
      props.chartTo(0)
    }
    else if (rdd.isMobile && browserH > browserW) {
      redirectBackFromSeasonals();
    }
  }
  //-----------------------------------------------------------------------------------------------------------
  const handleLayer2Visible = () => {

    if (secondLayerControlsOpen) {
      // displayElement[13] = 'none';
      SetSecondLayerDisplay('none')
      SetSecondLayerControlsOpen(false)
    }
    else {
      // displayElement[13] = 'flex';
      SetSecondLayerDisplay('flex')
      SetSecondLayerControlsOpen(true)
    }
  }

  const handleHelpClicked = () => {
    // props.SetHelpBoxVisible(!props.helpBoxVisible);  remove the old help 9/14/2022

    // new help 9/14/2022
    // props.SetDialogType('quick-help');
    // props.SetInfoBoxVisible(true); 
    props.SetVideosBoxVisible(true)

    console.log('question clicked')

  }

  const handleExport = () => {
    props.SetExportImage(true)
  }

  // this is triggered when trend chart icon is clciked on mobile portrait
  const handleSCclicked = () => {
    if (browserH > browserW) props.chartTo(4);
    else props.chartTo(5);
  }


  const yearsDisplay = () => {

    let year_text = ' Y';
    if (!rdd.isMobile) year_text = '-Year';

    let val = Number(props.seasonalYears) ? true : false; // if false its a custom year - only show seasonalchart with jan-dec checked
    if (val === false) {
      return customYearsDesc[props.seasonalYears];
    }
    else return props.seasonalYears + year_text;
  }



  //-------------------------------------------------------------------------------------------------------------------------------------
  // new report added by clicking the plus in reports dashboard dialog
  // THIS FUNCTION IS DUPLICATED IN REPORTS DASHBAROD DUE TO ISSUES WITH PROPS SCOPE - CHANGES ARE REQUIRED IN BOTH PLACES
  //------------------------------------------------------------------------------------------------------------------------------------- 
  const handleAddReport = () => {
    // new report added by clicking the plus in reports dashboard dialog
    // check if this report can be added based on how many reports are allowed for this user and how many have already been created
    // numReportsAllowed is already determined from login - returned by useContext

    // console.log('handleAddReport clicked')


    if (loggedinUser === '0') {
      props.SetDialogType('info-box');
      // props.SetDialogProp({ title: 'Opportunities Dashboard', contentText: 'With Opportunities Dashboard users can save and create Date-Range Web Reports.  This feature is available to Loggedin-Users.', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' });
      props.SetDialogProp({ title: 'Portfolio Manager', contentText: opp_dashboard_dialog_content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' });
      props.SetInfoBoxVisible(true);
    }
    else {
      // console.log('if logoed in user is not 0')
      if (props.numReportsCreated >= props.numReportsAllowed) {
        // this user cannot create any more reports unless they delete some first
        // let content = `you have reached the maximum number of reports allowed (${props.numReportsAllowed}). To create a new Date-Range-Report, you need to delete an existing report. You can manage your existing reports with Opportunities Manager, which can be accessed by clicking below or by the clipboard with a pencil icon.`
        let content = `You have reached the maximum number of tracked opportunities allowed for your current subscription level.  Your subscription allows for ${props.numReportsAllowed} opportunities to be saved. To track additional opportunities in your portfolio, consider upgrading your subscription.`

        // console.log(props.numReportsCreated, props.numReportsAllowed)

        if (props.numReportsCreated >= props.numReportsAllowed) {
          content = `You have exceeded the maximum number of tracked opportunities allowed for your current subscription level.  Your subscription allows for ${props.numReportsAllowed} opportunities to be saved while you have ${props.numReportsCreated} opportunities in your portfolios. Please remove some of the tracked opportunities to match the allowed opportunities for your subscription level. To track additional opportunities in your portfolio, consider upgrading your subscription.`
        }
        props.SetDialogType('info-box');
        props.SetDialogProp({ title: 'Opportunities Limit Reached', contentText: content, button1Text: 'Subscriptions', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
        props.SetInfoBoxVisible(true);
      }

      else {
        // console.log('begin calling dr_report_publish')


        let id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)

        if (id >= 0) {

          let symbol = props.symbol
          let date = props.startDate
          let days_hold = props.daysOut;
          let years = props.seasonalYears;
          let direction = props.tradeDetailData['Trade Dir']
          let sharpe_ratio = props.tradeDetailData['Sharpe Ratio']
          let selected_portfolio = props.selectedPortfolio;

          let cumulative_return = props.tradeDetailData['Cumulative Return'] // have not passed added this yet 

          // console.log('............... length of reportslist = ', props.reprotsList.length)

          let asURL = appserverURL()
          let url = `${asURL}/dr_report_publish/${id}/${symbol}/${date}/${days_hold}/${years}/${direction}/${sharpe_ratio}/${selected_portfolio}?token=${token}`

          // console.log('add report url in seasonalbarchart',url)

          fetch(url)
            .then((response) => {
              // console.log('response=',response)
              if (!response.ok) {
                throw new Error(response.status); // throw an error if the response status is not OK
              }
              return response.json();
            })
            .then((data) => {

              // console.log('--------add report returned ---', props.numReportsAllowed, props.numReportsCreated)

              if (data['publish_dr_report'] === 'success') {
                props.SetNumReportsCreated(props.numReportsCreated + 1) // increment the number of reports created
                let contentText = `Opportunity Added - ${(props.numReportsAllowed - props.numReportsCreated - 1)} Remaining`;
                props.SetDialogProp({ title: 'delay', contentText: contentText, button1Text: '', button2Text: '', coverDivColor: 'rgb(222,222,222,0)' })
              }
              else if (data['publish_dr_report'] === 'duplicate') {
                props.SetDialogProp({ title: 'delay', contentText: 'Duplicate', button1Text: '', button2Text: '', coverDivColor: 'rgb(222,222,222,0)' })
              }
              else if (data['publish_dr_report'] === 'daily_limit_reached') {
                let limit = data['limit'];
                let daily_limit_content = `Your daily limit of ${limit} opportunities per day has been reached.  
              You can add new opportunities to your portfolio after midnight eastern timezone.
              To increase your daily limit, please consider upgrading your subscription.
              `
                props.SetDialogProp({ title: 'Daily Limit Reached', contentText: daily_limit_content, button1Text: 'Subscriptions', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
              }
              else { // should not happen
                props.SetDialogProp({ title: 'delay', contentText: 'should not happen', button1Text: '', button2Text: '', coverDivColor: 'rgb(222,222,222,0)' })
              }
              // console.log('before calling info-box')
              props.SetDialogType('info-box');
              props.SetInfoBoxVisible(true)
            })
            .catch((error) => {
              if (error.message === '404') {
                console.log('Resource not found'); // handle a 404 error response
              } else {
                console.log('Error:', error.message); // handle any other error response
              }
            });

          props.SetReportsList([])
        }
        else {
          console.log('market id returned = -1 should not happen: props.securityTypeList, props.selectedSecurity=', props.securityTypeList, props.selectedSecurity)
        }




      }



    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------------





  //--------------------------------------------------------------------------------
  return (

    <div className="seasonal-barchart-container">

      {/* _______________________________________________container_________________________________________________________ */}

      <div className="barchart-controls" style={barchartControlsStyle} >

        <div className="barchart-controls-div" style={StyleNavDiv} >

          <div style={StyleForwardArrow}>
            <button className="nav-buttons">
              <FaAngleRight size={30} style={{ fill: "white" }} onClick={handleForwardClick} />
            </button>
          </div>

          {/* <BiExport size={20} style={{ fill: "white" }} onClick={handleExport} /> */}

        </div>

        {
          props.seasonalBarChartData.length > 0 &&

          <Tippy placement={'bottom'} content={
            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
              {props.tooltipSW ? 'Click the Plus icon to save the Date-Range-Opportunity to your portfolio.  All saved opportunities also generate a comprehensive Web Report that can be viewed and shared.  Your portfolio can be accessed by Clicking the Opportunities Manager icon, that looks like a clipboard with a pencil' : ''}
            </div>
          }>
            <div style={{ backgroundColor: 'transparent' }}>
              <BsPlus size={icon_size_plus} style={{ fill: "white", backgroundColor: "transparent", verticalAlign: 'bottom' }} onClick={handleAddReport} />
            </div>

          </Tippy>

        }
        <div style={StyleDescription} >
          {props.symbol !== '' &&

            <span>
              <Tippy placement={'bottom'} content={
                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                  {props.tooltipSW ? props.seasonalYears + 'Y is the number of years seasonal viewer is showing previous years profits.  To increase or decrease the number of years, select the desired number of years on the select box above seasonal viewer' : ''}
                </div>
              }>

                <span style={{ display: descpart1, fontWeight: 'bold' }}>{yearsDisplay()}&nbsp;</span>

              </Tippy>


              <Tippy placement={'bottom'} content={
                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                  {props.tooltipSW ? 'Ticker Symbol for the security' : ''}
                </div>
              }>
                {/* <span style={{ color: "red", display: descpart1 }}><strong>{ticker_description}</strong>&nbsp;</span> */}
                {/* "#FFD700"  */}
                <span style={{ color: UIcolors(loggedinUser)['symbol_color'], display: descpart1, fontWeight: 'bolder' }}><strong>{props.symbol}</strong>&nbsp;</span>
              </Tippy>


              <Tippy placement={'bottom'} content={
                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                  {props.tooltipSW ? 'Date Range for the Wave strategy' : ''}
                </div>
              }>
                <span style={{ fontWeight: 'bold', marginTop: '1px', border: '1px solid white', paddingLeft: '2px', paddingRight: '1px', marginRight: '8px' }}>{dateStartDisp} to {dateEndDisp} &nbsp;  </span>
              </Tippy>
            </span>
          }
        </div>






        {/* this is for 2nd layer for smartphone portraits - rect that drops when down triangle clicked*/}

        {/* mobile seasonal chart icon jumps to seasonal chart quickly */}
        <div style={{ width: SVDIVwidth, display: displayElement[14], justifyContent: 'center', backgroundColor: 'transparent' }} onClick={handleSCclicked} >
          <BiLineChart size={svIconSize} style={{ fill: "white" }} />
        </div>


        <div style={{ width: '12%', height: '100%', display: displayElement[12], alignItems: 'center', justifyContent: 'center' }} onClick={handleLayer2Visible}>
          {secondLayerControlsOpen === true
            ? <BsFillCaretUpFill size={20} style={{ fill: "white" }} />
            : <BsFillCaretDownFill size={20} style={{ fill: "white" }} />
          }
        </div>
        {/* absolute position for 2nd layer on smartphone portrait */}
        <div className="second-layer-parent" style={{ display: secondLayerDisplay }}>
          <div className='barchart-controls-div2' >
            <TextBox text={props.startDate} width="9" tbBlur={handleBlur} tbEnter={handleEnter} name="date" securityTypeList2={props.securityTypeList2} selectedSecurity={props.selectedSecurity} />
          </div>



          <div className='barchart-controls-div2' >
            <TextBox text={props.symbol} width="5" tbBlur={handleBlur} tbEnter={handleEnter} name="symbol" securityTypeList2={props.securityTypeList2} selectedSecurity={props.selectedSecurity} qparams={props.qparams} />
          </div>

          <div className='barchart-controls-div2' >
            <SelectBox optionList={daysOutList} value={props.daysOut} suffix=" days" name="daysout" sbChanged={selectboxChanged} />
          </div>

          <div className='barchart-controls-div2' >
            <SelectBox optionList={seasonalYearsList} value={props.seasonalYears} suffix=" years" name="years" sbChanged={selectboxChanged} />
          </div>
        </div>



        <div style={{ display: "flex", alignItems: "center", height: "90%", backgroundColor: 'transparent' }}>

          {props.seasonalBarChartData.length > 0 &&
            <div className='barchart-controls-div' style={StyleLSSquare}>
              <Tippy placement={'bottom'} content={
                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                  {props.tooltipSW ? 'Color of square can be red or green.  WaveViewer determines if the current date range should be analyzed as bullish or bearish.  Bullish trade have at least 50% of years as bullish.  The only special condition is for Buy & Hold - Buy and Hold is always analyzed as bullish even if there are more losing years than winning years.' : ''}
                </div>
              }>
                <div style={longShortSquare}  ></div>

              </Tippy>
            </div>
          }


          <div className='barchart-controls-div' style={StyleMFE}>
            <CheckBox tooltipContent={props.tooltipSW ? 'b,MFE: Maximum Favorable Excursion, adds the maximum level the price reached in favor of the trade as light green on bullish and light red on bearish barcharts' : ''} label="MFE" cbChanged={checkboxChanged} checked={props.showMFE} />
          </div>

          <div className='barchart-controls-div' style={StyleMAE}>
            <CheckBox tooltipContent={props.tooltipSW ? 'b,MAE: Maximum Adverse Excursion, adds the maximum price reached against the trade as light red on bullish and light green on bearish barchars' : ''} label="MAE" cbChanged={checkboxChanged} checked={props.showMAE} />
          </div>

          <div className='barchart-controls-div' style={StyleStartDate}>
            <TextBox securityTypeList2={props.securityTypeList2} selectedSecurity={props.selectedSecurity} tooltipContent={props.tooltipSW ? 'b,Start Date to analyze a Wave' : ''} text={props.startDate} width={barchartControlDateWidth} tbBlur={handleBlur} tbEnter={handleEnter} name="date" />
          </div>

          <div className='barchart-controls-div' style={StyleSymbol}>
            <TextBox securityTypeList2={props.securityTypeList2} selectedSecurity={props.selectedSecurity} tooltipContent={props.tooltipSW ? 'b,Ticker Symbol to analyze.  Ticker must be a part of current securities group' : ''} text={props.symbol} width={barchartControlTickerWidth} tbBlur={handleBlur} tbEnter={handleEnter} name="symbol" qparams={props.qparams} />
          </div>

          <div className='barchart-controls-div' style={StyleDaysOut}>
            <SelectBox tooltipContent={props.tooltipSW ? 'b,Wave Viewer Control: Select number of days for the date range.  Date Range is calculated by calendar days after the Start Date' : ''} optionList={daysOutList} value={props.daysOut} suffix=" days" name="daysout" sbChanged={selectboxChanged} />
          </div>

          {/* date2 is only shown on desktop for now  */}
          {showDate2 &&
            <div className='barchart-controls-div' style={StyleStartDate}>
              <TextBox securityTypeList2={props.securityTypeList2} selectedSecurity={props.selectedSecurity} tooltipContent={props.tooltipSW ? 'b,End Date to analyze a Wave' : ''} text={dateEnd} width={barchartControlDateWidth} tbBlur={handleBlur} tbEnter={handleEnter} name="date2" />
            </div>
          }



          <div className='barchart-controls-div' style={StyleSeasonalYears}>
            <SelectBox tooltipContent={props.tooltipSW ? 'b,SeasonalViewer Control: Select number of years to analyze Seasonality.  Maximum number of years is adjusted based on available data.' : ''} optionList={seasonalYearsList} value={props.seasonalYears} suffix=" years" name="years" sbChanged={selectboxChanged} />
          </div>
          <div className='barchart-controls-div' style={StyleMQtrs}>
            <SelectBox tooltipContent={props.tooltipSW ? 'b,Premium Feature: TradeWave Shortcut to quickly enter date range for each month of the year, each season and by each quarter.  You can also select shortcuts for the following date ranges: "Year To Date", "Today to Year End" and "Buy & Hold" . \n When Reverse Date Range is selected, the resulting date range is the entire year except the initial date range.' : ''} optionList={monthsAndQtrs} name="monthsAndQtrs" value={props.monthsAndQtrs} sbChanged={selectboxChanged} />
          </div>
        </div>


        <div style={{ width: questionDivWidth, height: '100%', display: displayElement[13], alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent' }}>
          <BsQuestionCircle size={questionSize} style={{ fill: "white" }} onClick={handleHelpClicked} />
        </div>


      </div>



      <div className="barchart" style={barchartStyle}>
        {
          props.seasonalBarChartData.length > 0
            ? <BarChart seasonalBarChartData={props.seasonalBarChartData} showMAE={props.showMAE} showMFE={props.showMFE} barClicked={barClicked} barChartLongOrShort={props.barChartLongOrShort} showWatermark={props.showWatermark} />
            : <div className='barchart-background'>
              <span style={{ fontSize: svFont, color: 'rgb(153, 196, 210)' }} >{brand['barchart']}</span>
            </div>
        }
      </div>

      {/* _______________________________________________end of container_________________________________________________________ */}

    </div>
  )
}

export default SeasonalBarChart


